import { render, staticRenderFns } from "./BrainTreeEZ.vue?vue&type=template&id=bf141d40&scoped=true&"
import script from "./BrainTreeEZ.vue?vue&type=script&lang=js&"
export * from "./BrainTreeEZ.vue?vue&type=script&lang=js&"
import style0 from "./BrainTreeEZ.vue?vue&type=style&index=0&id=bf141d40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf141d40",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard,VCardText})
